import { render, staticRenderFns } from "./PredictionChoiceDraw.vue?vue&type=template&id=2313ac6e&"
import script from "./PredictionChoiceDraw.vue?vue&type=script&lang=js&"
export * from "./PredictionChoiceDraw.vue?vue&type=script&lang=js&"
import style0 from "./PredictionChoiceDraw.vue?vue&type=style&index=0&id=2313ac6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports